// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3z6ZR","visuallyhidden":"_3zgGz","hide-text":"_1hJt5","center":"_2dIOt","noprint":"_2HGwp","nt-disclaimer":"_4nDT8"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-nt-disclaimer/styles/default.scss
 ** module id = 1014
 ** module chunks = 2
 **/